import { PageNumber, MoreIndicator, NavigationButton } from './index';
import clsx from 'clsx';

type Props = {
  pages: number;
  currentPage: number;
  alignment?: 'center' | 'left' | 'right';
  inverse?: boolean;
  onClick: (page: number) => void;
};

const renderPageButtons = ({ pages, currentPage, inverse = false, onClick }: Props) => {
  const pageButtons = [];
  const firstPage = 1;
  const lastPage = pages;

  // Show all page numbers if 7 or fewer pages
  if (pages <= 7) {
    for (let i = 1; i <= lastPage; i++) {
      pageButtons.push(
        <PageNumber key={i} pageNumber={i} active={currentPage === i} inverse={inverse} onClick={onClick} />
      );
    }
  } else {
    // Selected page is 3 or less, then show first 5 pages follow by ... and the last page number
    if (currentPage <= 3) {
      for (let i = 1; i <= 5; i++) {
        pageButtons.push(
          <PageNumber key={i} pageNumber={i} active={currentPage === i} inverse={inverse} onClick={onClick} />
        );
      }
      pageButtons.push(<MoreIndicator inverse={inverse} />);
      pageButtons.push(
        <PageNumber
          key={lastPage}
          pageNumber={lastPage}
          active={currentPage === lastPage}
          inverse={inverse}
          onClick={onClick}
        />
      );
    }
    // Selected page is 3rd from the end or less, then show last 5 pages follow by ... and the first page number
    else if (currentPage >= lastPage - 2) {
      pageButtons.push(
        <PageNumber
          key={firstPage}
          pageNumber={firstPage}
          active={currentPage === firstPage}
          inverse={inverse}
          onClick={onClick}
        />
      );
      pageButtons.push(<MoreIndicator inverse={inverse} />);
      for (let i = pages - 4; i <= pages; i++) {
        pageButtons.push(
          <PageNumber key={i} pageNumber={i} active={currentPage === i} inverse={inverse} onClick={onClick} />
        );
      }
    }
    // Show first page number follow by ... and previous page number - current page number - next page number. Follow by ... and the last page number
    else {
      pageButtons.push(
        <PageNumber
          key={firstPage}
          pageNumber={firstPage}
          active={currentPage === 1}
          inverse={inverse}
          onClick={onClick}
        />
      );
      if (currentPage >= 3) {
        pageButtons.push(<MoreIndicator inverse={inverse} />);
      }

      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pageButtons.push(
          <PageNumber key={i} pageNumber={i} active={currentPage === i} inverse={inverse} onClick={onClick} />
        );
      }
      if (currentPage <= lastPage - 3) {
        pageButtons.push(<MoreIndicator inverse={inverse} />);
      }

      if (currentPage <= lastPage - 3) {
        pageButtons.push(<MoreIndicator inverse={inverse} />);
      }
      pageButtons.push(
        <PageNumber
          key={lastPage}
          pageNumber={lastPage}
          active={currentPage === lastPage}
          inverse={inverse}
          onClick={onClick}
        />
      );
    }
  }

  return pageButtons;
};

const PaginationSection = ({ pages, currentPage, alignment = 'center', inverse = false, onClick }: Props) => {
  return (
    <div
      className={`flex w-full gap-8 ${clsx({
        'justify-center': alignment === 'center',
        'justify-start': alignment === 'left',
        'justify-end': alignment === 'right',
      })}`}
    >
      <NavigationButton
        pages={pages}
        currentPage={currentPage}
        onClick={onClick}
        navigation={'prev'}
        inverse={inverse}
        disabled={currentPage === 1}
      />
      {renderPageButtons({ pages, currentPage, inverse, onClick })}
      <NavigationButton
        pages={pages}
        currentPage={currentPage}
        onClick={onClick}
        navigation={'next'}
        inverse={inverse}
        disabled={currentPage === pages}
      />
    </div>
  );
};
export default PaginationSection;
